module.exports = __webpack_public_path__ + "static/oluwarotimi-890883cd84f44608950169f683fcd45d.png";